var _effectorFileName = "/builds/gmini/ui-common/src/Popup/Portal.tsx";
import ReactDOM from 'react-dom';
export var Portal = function Portal(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/ReactDOM.createPortal(children, document.body);
};